module.exports = require("@one-chain/core");